module.exports = __webpack_public_path__ + "static/img/img_service_ensure@3x.1877132e.png";